import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

enum NovationTypeEnumeration {
  RP = '688d2ccfd65311eeafb016428df9c65f',
  RF = '6cc3052bd65311eeafb016428df9c65f',
  RNE = '0f4baf83a85411efadda0e54148beb9d',
}

@Injectable({
  providedIn: 'root',
})
export class NovationTypeGuard implements CanActivate {
  private readonly validNovationTypeIds = [
    NovationTypeEnumeration.RF,
    NovationTypeEnumeration.RNE,
    NovationTypeEnumeration.RP,
  ];

  constructor(private readonly router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> | boolean {
    const currentNovationTypeId = route.queryParams['novationTypeId'];
    return this.validateNovationTypeId(currentNovationTypeId);
  }

  public validateNovationTypeId(currentNovationTypeId: NovationTypeEnumeration): Promise<UrlTree | boolean> | boolean {
    if (!this.validNovationTypeIds.includes(currentNovationTypeId)) {
      return this.router.navigate(['/home']);
    }
    return true;
  }
}
